import React, { FunctionComponent } from 'react';
import { Layout } from 'antd';
import {
  Router,
  Switch,
  Route,
} from "react-router-dom";
import * as H from 'history';

import { Header } from '../../components/Header';
import { FinishRegistration } from '../../components/Authentication/FinishRegistration';
import { PasswordChange } from '../../components/Authentication/PasswordChange';
import { Login } from '../../components/Authentication/Login';
import { Message } from '../../components/common/Message';
import { Welcome } from '../../components/Authentication/Welcome';
import { CompanyRouter } from '../../components/Company/router';
import { StudentProfile } from '../../components/Profile/StudentProfile';
import { KnowledgeBasesRouter } from '../../components/KnowledgeBase/router';
import { CampaignsRouter } from '../../components/Campaign/router';
import { Reports } from '../../components/Reports';
import { LoggedUserProfile } from '../../components/LoggedUser/LoggedUserProfile';
import ScrollToTop from '../../components/common/ScrollToTop';
import { AllNotifications } from '../../components/Students/Notifications';
import { Notifications } from '../../components/Notifications';
import { Profile } from "../../components/Profile";
import { PrintableProfile } from "../../components/Printable/Profile";
import { AnalyticsCompanyDimSetter } from '../../components/common/AnalyticsCompanyDimSetter';
import { CoursesRouter } from "../../components/Courses/router";
import { TopicRouter } from "../../components/Topic/router";
import { LessonsRouter } from "../../components/Lesson/router";
import { EvaluationsRouter } from "../../components/Evaluation/router";
import { ProgramRouter } from "../../components/Program/router";
import { Prefixes } from '../../components/prefixes';
import { UsersRouter } from '../../components/Users/router';
import { Gamification } from '../../components/Gamification';
import { Customize } from '../../components/Customize';
import { GroupRouter } from '../../components/Group/router';

const { Content } = Layout;

interface AdminRouterProps {
  history: H.History<any>;
}

const CompanyAdminRouter: FunctionComponent<AdminRouterProps> = ({ history }) => {
  return <Router history={history}>
    <AnalyticsCompanyDimSetter />
    <ScrollToTop />
    <Layout>
      <Header isLoggedIn />
      <Content className="site-layout" style={{ position: "relative" }}>
        <Switch>
          <Route path="/my-profile/:tab">
            <LoggedUserProfile />
          </Route>
          <Route path="/new-password">
            <FinishRegistration />
          </Route>
          <Route path="/change-password">
            <PasswordChange />
          </Route>
          <Route path="/welcome">
            <Welcome />
          </Route>
          <Route path={Prefixes.group}>
            <GroupRouter history={history} />
          </Route>
          <Route path={Prefixes.company}>
            <CompanyRouter history={history} />
          </Route>
          <Route path="/students/:id/print">
            <PrintableProfile />
          </Route>
          <Route path="/students/:id">
            <StudentProfile />
          </Route>
          <Route path="/users">
            <UsersRouter history={history} />
          </Route>
          <Route path="/admin-users/:id/print">
            <PrintableProfile />
          </Route>
          <Route path="/admin-users/:id">
            <Profile />
          </Route>
          <Route path={Prefixes.campaign}>
            <CampaignsRouter history={history} />
          </Route>
          <Route path={Prefixes.lesson}>
            <LessonsRouter history={history} />
          </Route>
          <Route path="/evaluations">
            <EvaluationsRouter history={history} />
          </Route>
          <Route path="/courses">
            <CoursesRouter history={history} />
          </Route>
          <Route path={Prefixes.topic}>
            <TopicRouter history={history} />
          </Route>
          <Route path={Prefixes.program}>
            <ProgramRouter history={history} />
          </Route>
          <Route path={Prefixes.knowledgeBase}>
            <KnowledgeBasesRouter history={history} />
          </Route>
          <Route path="/reports">
            <Reports />
          </Route>
          <Route path="/notifications">
            <Notifications />
          </Route>
          <Route path="/gamification">
            <Gamification />
          </Route>
          <Route path="/company-customize">
            <Customize />
          </Route>
          <Route path="/all/notifications">
            <AllNotifications />
          </Route>
          <Route path="/">
            <Login />
          </Route>
        </Switch>
      </Content>
      <Message />
    </Layout>
  </Router>
};

export default CompanyAdminRouter;